import { push } from 'modules/gtm/modules/common';

export const gtmPushInternalSearch = (
  query: string,
  count: number,
  isSuggestionEvent = false,
) => {
  push({
    event: 'Generic Event',
    event_name: 'internal_search',
    internal_search: {
      search_term: query,
      search_results: count,
      event_category: isSuggestionEvent
        ? 'search suggestion'
        : 'internal search',
      event_action: 'own search',
      event_label: query,
    },
  });
};
